import {injectGlobal} from '@emotion/css';
import eot from './iconfont.eot';
import woff from './ionicons.woff';
import ttf from './iconfont.ttf';
import svg from './iconfont.svg';

injectGlobal`
    @font-face {
      font-family: "kpc-font";
      src: url('${eot}'); /* IE9 */
      src: url('${eot}#iefix') format('embedded-opentype'), /* IE6-IE8 */
      url('data:application/x-font-woff2;charset=utf-8;base64,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') format('woff2'),
      url('${woff}') format('woff'),
      url('${ttf}') format('truetype'), /* chrome, firefox, opera, Safari, Android, iOS 4.2+ */
      url('${svg}#kpc-font') format('svg'); /* iOS 4.1- */
    }

    .k-icon {
      font-family: "kpc-font";
      font-style: normal;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    .k-icon-alert:before {
      content: "\\e62f";
    }

    .k-icon-alarm:before {
      content: "\\e630";
    }

    .k-icon-calendar:before {
      content: "\\e631";
    }

    .k-icon-application:before {
      content: "\\e632";
    }

    .k-icon-arrow-right:before {
      content: "\\e633";
    }

    .k-icon-arrow-expand:before {
      content: "\\e634";
    }

    .k-icon-arrow-left-circled:before {
      content: "\\e635";
    }

    .k-icon-close:before {
      content: "\\e636";
    }

    .k-icon-arrow-right-circled:before {
      content: "\\e637";
    }

    .k-icon-bill:before {
      content: "\\e638";
    }

    .k-icon-change:before {
      content: "\\e639";
    }

    .k-icon-cloud-download:before {
      content: "\\e63a";
    }

    .k-icon-content-squared:before {
      content: "\\e63b";
    }

    .k-icon-cloud:before {
      content: "\\e63c";
    }

    .k-icon-arrow-up:before {
      content: "\\e63d";
    }

    .k-icon-arrow-move:before {
      content: "\\e63e";
    }

    .k-icon-code-download:before {
      content: "\\e63f";
    }

    .k-icon-cloud-server:before {
      content: "\\e640";
    }

    .k-icon-arrow-shrink:before {
      content: "\\e641";
    }

    .k-icon-clone:before {
      content: "\\e642";
    }

    .k-icon-cloud-servers:before {
      content: "\\e643";
    }

    .k-icon-cart:before {
      content: "\\e644";
    }

    .k-icon-delete:before {
      content: "\\e645";
    }

    .k-icon-fault-outline:before {
      content: "\\e646";
    }

    .k-icon-calculate:before {
      content: "\\e647";
    }

    .k-icon-arrow-swap:before {
      content: "\\e648";
    }

    .k-icon-download:before {
      content: "\\e649";
    }

    .k-icon-information:before {
      content: "\\e64a";
    }

    .k-icon-internet:before {
      content: "\\e64b";
    }

    .k-icon-edit:before {
      content: "\\e64c";
    }

    .k-icon-search:before {
      content: "\\e64d";
    }

    .k-icon-code-working:before {
      content: "\\e64e";
    }

    .k-icon-heart:before {
      content: "\\e64f";
    }

    .k-icon-content:before {
      content: "\\e650";
    }

    .k-icon-cut:before {
      content: "\\e651";
    }

    .k-icon-money-square:before {
      content: "\\e652";
    }

    .k-icon-logout:before {
      content: "\\e653";
    }

    .k-icon-cloud-upload:before {
      content: "\\e654";
    }

    .k-icon-lock:before {
      content: "\\e655";
    }

    .k-icon-corporate:before {
      content: "\\e656";
    }

    .k-icon-truth-none:before {
      content: "\\e657";
    }

    .k-icon-resize:before {
      content: "\\e658";
    }

    .k-icon-protect:before {
      content: "\\e659";
    }

    .k-icon-time:before {
      content: "\\e65a";
    }

    .k-icon-date:before {
      content: "\\e65b";
    }

    .k-icon-doucument-change:before {
      content: "\\e65c";
    }

    .k-icon-down:before {
      content: "\\e65d";
    }

    .k-icon-scanner:before {
      content: "\\e65e";
    }

    .k-icon-notification:before {
      content: "\\e65f";
    }

    .k-icon-heart-outline:before {
      content: "\\e660";
    }

    .k-icon-share:before {
      content: "\\e661";
    }

    .k-icon-pay:before {
      content: "\\e662";
    }

    .k-icon-picture:before {
      content: "\\e663";
    }

    .k-icon-desktop:before {
      content: "\\e664";
    }

    .k-icon-earphone:before {
      content: "\\e665";
    }

    .k-icon-cube:before {
      content: "\\e666";
    }

    .k-icon-user-verify:before {
      content: "\\e667";
    }

    .k-icon-fault:before {
      content: "\\e668";
    }

    .k-icon-left:before {
      content: "\\e669";
    }

    .k-icon-location:before {
      content: "\\e66a";
    }

    .k-icon-down-squared:before {
      content: "\\e66b";
    }

    .k-icon-pay-dollar:before {
      content: "\\e66c";
    }

    .k-icon-paperclip:before {
      content: "\\e66d";
    }

    .k-icon-arrow-left:before {
      content: "\\e66e";
    }

    .k-icon-settings:before {
      content: "\\e66f";
    }

    .k-icon-home:before {
      content: "\\e670";
    }

    .k-icon-more:before {
      content: "\\e671";
    }

    .k-icon-phonecall:before {
      content: "\\e672";
    }

    .k-icon-tag:before {
      content: "\\e673";
    }

    .k-icon-truth-circled:before {
      content: "\\e674";
    }

    .k-icon-refresh:before {
      content: "\\e675";
    }

    .k-icon-watch:before {
      content: "\\e676";
    }

    .k-icon-images:before {
      content: "\\e677";
    }

    .k-icon-sort:before {
      content: "\\e678";
    }

    .k-icon-money-circled:before {
      content: "\\e679";
    }

    .k-icon-trade:before {
      content: "\\e67a";
    }

    .k-icon-star-outline:before {
      content: "\\e67b";
    }

    .k-icon-minus-circled:before {
      content: "\\e67c";
    }

    .k-icon-right:before {
      content: "\\e67d";
    }

    .k-icon-upward:before {
      content: "\\e67e";
    }

    .k-icon-up-circled:before {
      content: "\\e67f";
    }

    .k-icon-pin:before {
      content: "\\e680";
    }

    .k-icon-hide:before {
      content: "\\e681";
    }

    .k-icon-users:before {
      content: "\\e682";
    }

    .k-icon-return-right:before {
      content: "\\e683";
    }

    .k-icon-message:before {
      content: "\\e684";
    }

    .k-icon-paper:before {
      content: "\\e685";
    }

    .k-icon-phonecall-prohibit:before {
      content: "\\e686";
    }

    .k-icon-speedometer:before {
      content: "\\e687";
    }

    .k-icon-settings-horizontal:before {
      content: "\\e688";
    }

    .k-icon-phone:before {
      content: "\\e689";
    }

    .k-icon-star:before {
      content: "\\e68a";
    }

    .k-icon-play:before {
      content: "\\e68b";
    }

    .k-icon-refresh-lock:before {
      content: "\\e68c";
    }

    .k-icon-shield:before {
      content: "\\e68d";
    }

    .k-icon-notification-outline:before {
      content: "\\e68e";
    }

    .k-icon-panel:before {
      content: "\\e68f";
    }

    .k-icon-structure:before {
      content: "\\e690";
    }

    .k-icon-settings-vertical:before {
      content: "\\e691";
    }

    .k-icon-printer:before {
      content: "\\e692";
    }

    .k-icon-stop:before {
      content: "\\e693";
    }

    .k-icon-return-left:before {
      content: "\\e694";
    }

    .k-icon-question:before {
      content: "\\e695";
    }

    .k-icon-unlock:before {
      content: "\\e696";
    }

    .k-icon-sound-off:before {
      content: "\\e697";
    }

    .k-icon-up:before {
      content: "\\e698";
    }

    .k-icon-up-squared:before {
      content: "\\e699";
    }

    .k-icon-silent:before {
      content: "\\e69a";
    }

    .k-icon-user:before {
      content: "\\e69b";
    }

    .k-icon-sound-on:before {
      content: "\\e69c";
    }

    .k-icon-upload:before {
      content: "\\e69d";
    }

    .k-icon-tool:before {
      content: "\\e69e";
    }

    .k-icon-visible:before {
      content: "\\e69f";
    }

    .k-icon-truth:before {
      content: "\\e6a0";
    }

    .k-icon-arrow-down:before {
      content: "\\e6a1";
    }
`;

